// extracted by mini-css-extract-plugin
export default {"meetingTimer":"UI0wl2VJmZzdixXzbAeW","signerCountdown":"E65nNqpKg_Fz4S6Hsn87"};